import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function MemberBookingDropdown({
  teamMemberList = [],
  teamsList = [],
  selectedTeamMember = "",
  selectedTeamId = null,
  isGuest = 0,
  onMemberSelect,
  onTeamSelect,
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = (() => {
    if (isGuest === 1) return t("guest");

    const member = teamMemberList.find((item) => item.GuId === selectedTeamMember);
    if (member) return member.FullName;

    const team = teamsList.find((item) => item.Id === selectedTeamId);
    if (team) return team.Name;

    return "-- Select --";
  })();

  if (!teamMemberList.length && !teamsList.length) {
    return null;
  }

  return (
    <div
      ref={dropdownRef}
      className="employee-list member-booking-dropdown"
    >
      <div className="dropdown form-input-container d-flex justify-content-center flex-column">
        <button
          className="dropdown-toggle position-relative custom-dropdown-btn"
          type="button"
          id="member-booking-dropdown-btn"
          name="memberbookingdropdown"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
        >
          <p className="sub-dropdown-name">{t("react_book_for")}</p>
          <span>{selectedLabel}</span>
        </button>

        {isOpen && (
          <ul
            className={`dropdown-menu custom-dropdown ${isOpen ? "show" : ""}`}
            aria-labelledby="member-booking-dropdown-btn"
            id="member-booking-dropdown"
          >
            {teamMemberList.length > 0 && (
              <li className="no-option-marker">
                <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                  {t("employees")}
                </div>
              </li>
            )}
            {teamMemberList.map((member) => (
              <li
                key={member.GuId}
                className={selectedTeamMember === member.GuId && selectedTeamId === null ? "selected" : ""}
                onClick={() => {
                  onMemberSelect?.(member);
                  setIsOpen(false);
                }}
              >
                <button
                  type="button"
                  className="dropdown-item"
                >
                  {member.FullName}
                </button>
              </li>
            ))}

            {teamsList.length > 0 && (
              <li className="no-option-marker">
                <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                  {t("teams")}
                </div>
              </li>
            )}

            {teamsList.map((team) => (
              <li
                key={team.Id}
                className={selectedTeamId === team.Id ? "selected" : ""}
                onClick={() => {
                  onTeamSelect?.(team);
                  setIsOpen(false);
                }}
              >
                <button
                  type="button"
                  className="dropdown-item"
                >
                  {team.Name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default MemberBookingDropdown;
